<template>
  <div>
    <el-form :model="queryForm" label-width="80px" style="margin-bottom:5px;display:flex;">
      <div class="tab_radio">
        <!-- <el-tabs v-model="queryForm.type" style="display:inline-block;float:left" @tab-click="handleClick1">
        <el-tab-pane label="今日财务" name="DAY"> </el-tab-pane>
        <el-tab-pane label="本月财务" name="MONTH"> </el-tab-pane>
        <el-tab-pane label="本年财务" name="YEAR"> </el-tab-pane>
      </el-tabs> -->
        <el-radio-group v-model="queryForm.type" style="margin-bottom:30px;float:left;display:inline-block;" text-color="#00a6ff" @change="reset">
          <el-radio-button label="DAY">今日</el-radio-button>
          <el-radio-button label="MONTH">本月</el-radio-button>
          <el-radio-button label="YEAR">本年</el-radio-button>
        </el-radio-group>
      </div>

      <div>
                <el-form-item label="自定义时间" style="margin-left:50px">
                     <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" />
      </el-form-item>
        <!-- <el-form-item label="开始时间" style="float:left">
          <el-date-picker v-model="queryForm.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" :clearable="false" />
        </el-form-item>
        <el-form-item label="结束时间" style="float:left">
          <el-date-picker v-model="queryForm.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" :clearable="false" />
        </el-form-item> -->
      </div>

      <el-form-item style="display:inline-block;">
        <!-- <el-button plain @click="more">{{ isPart ? "更多" : "隐藏" }}</el-button> -->
        <el-button type="primary" plain @click="query(true)">查询</el-button>
        <!-- <el-button plain @click="reset">重置</el-button> -->
        <el-button type="primary" plain @click="back">返回</el-button>
      </el-form-item>
    </el-form>
    <div class="box">
      <div class="company" >
        <div style="font-size:12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="detail.companyName">
          <span style="color:#999999;padding-left:15px">企业名称</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.companyName }}</span>
        </div>
        <div style="font-size:12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="detail.institutionCode">
          <span style="color:#999999;padding-left:15px">组织机构代码</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.institutionCode }}</span>
        </div>
        <div style="font-size:12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="detail.contactUser">
          <span style="color:#999999;padding-left:15px">联 系 人</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.contactUser }}</span>
        </div>
        <div style="font-size:12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="detail.contactNum">
          <span style="color:#999999;padding-left:15px">电 话</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.contactNum }}</span>
        </div>
        <div style="font-size:12px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" :title="detail.email">
          <span style="color:#999999;padding-left:15px">邮 箱</span>
          <span style="color:#333333;margin-left:16px;">{{ detail.email }}</span>
        </div>
      </div>
      <div class="other-info">
        <div style="width:16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-iconset0216" />
            <span style="font-size:17px;color:#333333;margin-left:6px;">充电度数（量）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalChargingDegree">{{ getFloat(detail.totalChargingDegree) }}</span>
            <!-- <span style="font-size:14px;color:#333333;">度</span> -->
          </div>
        </div>
        <div style="width:16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-dianfei" style="color:#00a6ff" />
            <span style="font-size:17px;color:#333333;margin-left:6px;">电费（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalElectricityBill">{{ getFloat(detail.totalElectricityBill) }}</span>
            <!-- <span style="font-size:14px;color:#333333;">元</span> -->
          </div>
        </div>
        <div style="width:16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-fuwufei" style="color:#00a6ff" />
            <span style="font-size:17px;color:#333333;margin-left:6px;">服务费（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalServiceCharge">{{ getFloat(detail.totalServiceCharge) }}</span>
            <!-- <span style="font-size:14px;color:#333333;">元</span> -->
          </div>
        </div>
        <div style="width:16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-yingshouzhangkuan" style="color:#f4ea2a" />
            <span style="font-size:17px;color:#333333;margin-left:6px;">应收金额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalPayableAmount">{{ getFloat(detail.totalPayableAmount) }}</span>
            <!-- <span style="font-size:14px;color:#333333;">元</span> -->
          </div>
        </div>
        <div style="width:16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-lirunbiao" style="color:#f4ea2a" />
            <span style="font-size:17px;color:#333333;margin-left:6px;">实收核对（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalAmountReceivable">{{ getFloat(detail.totalAmountReceivable) }}</span>
            <!-- <span style="font-size:14px;color:#333333;">元</span> -->
          </div>
        </div>
        <div style="width:16%">
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="iconfont icon-shishoufeiyong" style="color:#f4ea2a" />
            <span style="font-size:17px;color:#333333;margin-left:6px;">实收金额（元）</span>
          </div>
          <div>
            <span class="moneyNum" :title="detail.totalActualAmount">{{ getFixed2(detail.totalActualAmount) }}</span>
            <!-- <span style="font-size:14px;color:#333333;">元</span> -->
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;">
      <el-card>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="电桩" name="station" />
          <el-tab-pane label="订单" name="order" />
          <el-tab-pane label="对账单" name="bill">
            <el-button type="primary" plain style="float: right;" icon="el-icon-download" permission="finance.survey.export" @click="exportOrder">导出</el-button>
          </el-tab-pane>
        </el-tabs>
        <template v-if="activeName == 'station'">
          <el-table :data="tableData" stripe border style="width: 100%">
            <el-table-column type="index" align="center" width="50" label="序号" />
            <el-table-column label="电桩编号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.equipmentID }}</span>
              </template>
            </el-table-column>
            <el-table-column label="电桩名称" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.equipmentName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="归属电站" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.stationName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电接口类型" align="center">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.equipmentType==1 ? '直流设备' : scope.row.equipmentType==2 ? '交流设备' : scope.row.equipmentType==3 ? '交直流一体设备' : scope.row.equipmentType==4 ? '无线设备' : '其他' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="功率" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.power }}KW</span>
              </template>
            </el-table-column>
            <el-table-column label="度数" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.totalChargingDegree) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="电费" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.totalElectricityBill) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="服务费" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.totalServiceCharge) }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="应付金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.totalPayableAmount) }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="应收金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.totalPayableAmount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收核对" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.totalAmountReceivable) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFixed2(scope.row.totalActualAmount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电次数" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.count }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="activeName == 'order'">
          <el-table :data="tableData" stripe border style="width: 100%">
            <el-table-column type="index" align="center" width="50" label="序号" />
            <el-table-column label="订单编号" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="goToDetail(scope.row.id)">
                  {{ scope.row.startChargeSeq }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="用户归属企业" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.organizationName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电开始时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电结束时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电度数" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.chargingDegree) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="电费" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.electricityBill) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="服务费" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.serviceCharge) }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="应付金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.payableAmount) }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="应收金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.payableAmount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收核对" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.amountReceivable) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFixed2(scope.row.actualAmount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="订单状态" align="center">
              <template slot-scope="scope">
                <span>{{ getStatus(scope.row.orderStatus) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <template v-if="activeName == 'bill'">
          <el-table :data="tableData" stripe border style="width: 100%">
            <el-table-column type="index" align="center" width="50" label="序号" />
            <el-table-column label="订单号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.startChargeSeq }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电桩编码" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.equipmentId }}</span>
              </template>
            </el-table-column>
            <el-table-column label="电站名称" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.stationName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="用户归属企业" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.operatorName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电开始时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电结束时间" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="充电度数" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.chargingDegree) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="电费" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.electricityBill) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="服务费" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.serviceCharge) }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="应付金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.serviceCharge) }}</span>
              </template>
            </el-table-column> -->
            <el-table-column label="应收金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.payableAmount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收核对" align="center">
              <template slot-scope="scope">
                <span>{{ getFloat(scope.row.amountReceivable) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="实收金额" align="center">
              <template slot-scope="scope">
                <span>{{ getFixed2(scope.row.actualAmount) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-card>

      <div v-if="pageshow" style="float: left">
        <el-pagination :current-page="currentPage" :page-sizes="[10,20,30,40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>

<script>
// import x from ''
import {
  HOST
} from '@/utils/host'
export default {
  name: 'Benniancaiwu',
  components: {},
  data() {
    return {
      date:[],
      queryForm: {
        type: 'DAY',
        startTime: '',
        endTime: ''
      },
      isPart: true,
      activeName: 'station',
      detail: {},
      tableData: [],
      currentPage: 1, // 当前页
      total: 0, // 总页数
      pagesize: 10, // 每页条数
      pageshow: true
    }
  },
  computed: {},
  mounted() {
    this.getAccountDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    back() {
      this.$router.go(-1)
    },
    reset() {
      this.queryForm.startTime = ''
      this.queryForm.endTime = ''
                this.getAccountDetail()
    },
    more() {
      const isPart = this.isPart
      if (isPart) {
        this.isPart = false
      } else {
        this.isPart = true
      }
    },
    getStatus(e) {
      if (e === 0) {
        return '待支付'
      } else if (e === 1) {
        return '已支付'
      } else {
        return '异常'
      }
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.tableData = []
      if (this.activeName === 'station') {
        this.getAccountDetail()
      } else if (this.activeName === 'order') {
        this.getOrderDetail()
      } else if (this.activeName === 'bill') {
        this.getBillDetail()
      }
    },

    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      this.tableData = []
      if (this.activeName === 'station') {
        this.getAccountDetail()
      } else if (this.activeName === 'order') {
        this.getOrderDetail()
      } else if (this.activeName === 'bill') {
        this.getBillDetail()
      }
      // this.$nextTick(() => {
      //     this.pageshow = true;
      // });
    },

    exportOrder() {
      // const orgId = window.localStorage.getItem('curCompanyId');
      const url = HOST + '/finance/manage/export'
      $.fileDownload(url, {
        httpMethod: 'get',
        data: {
          orgId: this.id,
          timeType: this.queryForm.type,
          startTime: this.queryForm.startTime,
          endTime: this.queryForm.endTime,
          token: window.localStorage.getItem('token'),
          type: 'station',
          companyId: window.localStorage.getItem('curCompanyId')
        },
        failCallback: (html, url) => {
          this.$notify({
            title: '失败',
            message: '导出对账单失败',
            type: 'error'
          })
        }
      })
    },
    handleClick1(tab, event) {
      console.log(tab, 'tab', tab.name)
      this.queryForm.type = tab.name
      // this.getAccountDetail();
    },
    handleClick(tab, event) {
      this.activeName = tab.name
      this.tableData = []
      this.currentPage = 1
      if (this.activeName === 'station') {
        this.getAccountDetail()
      } else if (this.activeName === 'order') {
        this.getOrderDetail()
      } else if (this.activeName === 'bill') {
        this.getBillDetail()
      }
    },

    // 电桩列表
    getAccountDetail() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        timeType: this.queryForm.type,
        orgId: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage/station?type=station',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.orgAndFinanceResp) {
            this.detail = resp.orgAndFinanceResp
          }
          if (resp.overviewList.length > 0) {
            this.pageshow = true
            this.tableData = resp.overviewList
            this.total = resp.count
          } else {
            this.pageshow = false
          }
        }
      })
    },

    // 订单列表
    getOrderDetail() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        timeType: this.queryForm.type,
        orgId: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage/order?type=station',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.orgAndFinanceResp) {
            this.detail = resp.orgAndFinanceResp
          }
          if (resp.overviewList.length > 0) {
            this.pageshow = true
            this.tableData = resp.overviewList
            this.total = resp.count
          } else {
            this.pageshow = false
          }
        }
      })
    },

    // 对账单列表
    getBillDetail() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        startTime: this.queryForm.startTime,
        endTime: this.queryForm.endTime,
        timeType: this.queryForm.type,
        orgId: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/manage/compareBill?type=station',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.orgAndFinanceResp) {
            this.detail = resp.orgAndFinanceResp
          }
          if (resp.overviewList.length > 0) {
            this.pageshow = true
            this.tableData = resp.overviewList
            this.total = resp.count
          } else {
            this.pageshow = false
          }
        }
      })
    },

    query() {
            this.queryForm.startTime=(this.date&&this.date.length>0)?(this.date[0]+" 00:00:00"):''
      this.queryForm.endTime=(this.date&&this.date.length>0)?(this.date[1]+" 23:59:59"):''
      this.tableData = []
      this.currentPage = 1
      if (this.activeName === 'station') {
        this.getAccountDetail()
      } else if (this.activeName === 'order') {
        this.getOrderDetail()
      } else if (this.activeName === 'bill') {
        this.getBillDetail()
      }
    },

    // 去订单详情
    goToDetail(item) {
      this.$router.push({
        path: './orderDetail',
        query: {
          data: item
        }
      })
    }

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less">
.box {
  display: flex;
  height: 140px;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0 20px;
  .company {
    height: 135px;
    font-size: 14px;
    line-height: 25px;
    width: 290px;
    padding:5px 10px;
    border: 1px solid #c9c9c9;
   div{
     width:100%;
   }
  }
  .other-info{
    width:calc(100% - 330px);
    display:flex;
    align-items: center;
    justify-content: space-between;
    height: 135px;
    padding:5px 0px;
    border: 1px solid #c9c9c9;
      div {
      text-align: center;
      .moneyNum{
        font-size:26px;
        padding-top: 10px;
        color:#1890FF;
        font-weight:500;
        max-width: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .iconfont {
        font-size: 28px;
        font-weight: 600;
      }

      .icon-iconset0216 {
        color: #32F83E;
      }

      .icon-lirunbiao {
        color: #F2E743;
      }
      .icon-yingshouzhangkuan{
        color: #F2E743;
        font-size: 24px;
      }

      .icon-qianbao {
        color: #409eff;
      }

      .icon-qianbao1 {
        color: #409eff;
        font-size: 24px;
      }
      .icon-shishoufeiyong{
        font-size: 30px;
      }
    }
  }
}
.tab_radio{
  .el-radio-button__inner{
    width:82px;
    height:36px;
    line-height: 10px;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner{
    background: #ffffff;
    border: 1px solid #00a6ff;
    color: #00a6ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/summaryDetailFinancial.vue